

import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom'

const PrivateRoute2ndYear = ({ children }) => {
      const { isLoggedIn, userData, loginModale } = useSelector(
    (state) => state.auth,
  );

   if (!userData) {
    return <div>Loading...</div>;
  }


   if(!isLoggedIn ){
      return <Navigate to="/" replace/>
    }

   
 const admissions = userData?.admissions
 const admissionLength = admissions.length;


   const isCurrentYearAdmission = (admission) => {
    if (!admission) return false;
    const admissionYear = new Date(admission.created_at).getFullYear();
    const currentYear = new Date().getFullYear();
    return admissionYear === currentYear;
  };


   if (admissionLength > 0) {
      const latestAdmission = admissions[admissions.length - 1];
      
      if (isCurrentYearAdmission(latestAdmission)) {
        console.log("Form already filled for current year, redirecting to /admission-form");
        return <Navigate to="/admission-form" replace />;
      }
    }



 console.log("Private Route chla",admissions);









    //   const admissions = userData?.admissions || [];
    //   const admissionLength = admissions.length;

    // if (admissionLength > 0) {
    //     const latestAdmission = admissions[admissions.length - 1];
        
       
    //     if (isCurrentYearAdmission(latestAdmission)) {
    //       console.log("Form already filled for current year, redirecting to /admission-form");
    //       return <Navigate to="/admission-form" replace />;
    //     }
    //   }

   

       return children
   
}

export default PrivateRoute2ndYear